import _ from 'lodash';
import { Device } from '../../../lib';
import { VideoSource } from './types';

const getOrderFromOffset = (greatest: number, offset: number) => {
    return offset < 0 ? greatest - offset : offset;
};

const getOrderByDevice = (
    currentDevice: Device,
    videoTarget?: Device
): number => {
    const deviceToOrder: Record<Device, number> = {
        desktop: 3,
        tablet: 2,
        mobile: 1,
    };
    if (videoTarget === currentDevice) return 0;
    if (videoTarget)
        return getOrderFromOffset(
            3,
            deviceToOrder[videoTarget] - deviceToOrder[currentDevice]
        );
    return 5;
};

export const sortVideoSources = (
    videos: VideoSource[],
    currentDevice: Device
): VideoSource[] => {
    return _.sortBy(videos, [
        'format',
        video => getOrderByDevice(currentDevice, video.device),
    ]);
};

export const canPlay = (
    current: HTMLVideoElement | null
): current is HTMLVideoElement =>
    current !== null && typeof current.play === 'function';

export const shouldReload = (
    firstRender: boolean,
    lastUrl?: string,
    newUrl?: string
): boolean => {
    return !firstRender && lastUrl !== newUrl;
};

export const getFirstUrl = (videos?: VideoSource[]): string | undefined =>
    videos?.[0]?.url;
